import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import smjCreatorUtils from './utils';

import SMJAvailableCmpList from './SMJAvailableCmpList';
import SMJSelectedCmpList from './SMJSelectedCmpList';

import Card from 'src/components/common/Card';
import SMJCmpSelectorHelper from './SMJCmpSelectorHelper';
import SMJModelItem from './SMJModelItem';
import { Button } from '@mui/material';

 
const Ctn = ({ children, flex }) => (
  <div
    style={{
      display: 'flex',
      flex: flex || 1,
      margin: '8px 8px 8px 8px',
      flexDirection: 'column',
      padding: '0',
      overflow: 'hidden',
      position: 'relative',
    }}
  >
    {children}
  </div>
);

const GroupCreateCmpSelector = ({
  toSMJConfig,
  onBack,
  requestModelByRMTypeId,
  newGroupSetup,
  onSelect,
  getSelectedCmps,
}) => {
  const { t } = useTranslation();

  function getMappedSelection() {
    return smjCreatorUtils.mapSMJCmpModelMByType(getSelectedCmps());
  }
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        padding: '8px 8px 8px 8px',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <SMJCmpSelectorHelper />
      <div
        style={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        <Ctn flex="2">
          <Card
            title={t('smartmessaging.smartjourney.creator.availaibleCampaigns')}
            rootStyle={{ display: 'flex', flex: 1, flexDirection: 'column', overflow: 'hidden' }}
            contentStyle={{ display: 'flex', flex: 1, flexDirection: 'column', overflow: 'auto' }}
          >
            <SMJAvailableCmpList
              campaigns={smjCreatorUtils.mapSMJCmpModelMByType(newGroupSetup.groupModel.campaigns)}
              onSelect={onSelect}
              selection={newGroupSetup.campaignSelection}
              requestModelByRMTypeId={requestModelByRMTypeId}
            />
          </Card>
        </Ctn>
        <Ctn flex="3">
          <Card title={t('smartmessaging.smartjourney.creator.selectedSmjModel')}>
            <SMJModelItem disabledSelect smjModel={newGroupSetup.groupModel} />
          </Card>
          <Card
            rootStyle={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
            contentStyle={{ overflow: 'auto' }}
            title={t('smartmessaging.smartjourney.creator.selectedCampaigns')}
          >
            <SMJSelectedCmpList
              selection={getMappedSelection()}
              requestModelByRMTypeId={requestModelByRMTypeId}
            />
          </Card>
        </Ctn>
      </div>
      <div style={{ textAlign: 'right' }}>
        <Button
          variant="text"
          color="primary"
          style={{ margin: '2px' }}
          onClick={e => {
            e.preventDefault();
            onBack();
          }}
        >
          {t('smartmessaging.buttonLabel.previous')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: '2px' }}
          disabled={!newGroupSetup.campaignSelection.length}
          onClick={e => {
            e.preventDefault();
            toSMJConfig();
          }}
        >
          {t('smartmessaging.buttonLabel.next')}
        </Button>
      </div>
    </div>
  );
};

GroupCreateCmpSelector.propTypes = {
  toSMJConfig: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  requestModelByRMTypeId: PropTypes.object.isRequired,
  newGroupSetup: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  getSelectedCmps: PropTypes.func.isRequired,
};

export default GroupCreateCmpSelector;
